module.exports = __webpack_public_path__ + "static/media/1000887.7cdc0829.png";